import { render } from "./FactoryList.vue?vue&type=template&id=10dc58f9"
import script from "./FactoryList.vue?vue&type=script&lang=js"
export * from "./FactoryList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__